export enum QUERY_STRING_PARAMS {
  FILTER = 'filter',
  SORT = 'sort',
}
